import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { FleetProvider } from './FleetContext';
import LoginPage from './LoginPage';
import LandingPage from './LandingPage';
import Prototype1 from './pages/Prototype1';
import Prototype2 from './pages/Prototype2';
import Prototype3 from './pages/Prototype3';
import Prototype4 from './pages/Prototype4';
import Prototype5 from './pages/Prototype5';
import { CircularProgress, Box } from '@mui/material';
import { colors } from './theme/tokens';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{
        minHeight: '100vh',
        backgroundColor: colors.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <CircularProgress size={28} thickness={4} sx={{ color: colors.accentDeep }} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FleetProvider>
          <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <LandingPage />
            </ProtectedRoute>
          } />
          <Route path="/prototype/1" element={
            <ProtectedRoute>
              <Prototype1 />
            </ProtectedRoute>
          } />
          <Route path="/prototype/2" element={
            <ProtectedRoute>
              <Prototype2 />
            </ProtectedRoute>
          } />
          <Route path="/prototype/3" element={
            <ProtectedRoute>
              <Prototype3 />
            </ProtectedRoute>
          } />
          <Route path="/prototype/4" element={
            <ProtectedRoute>
              <Prototype4 />
            </ProtectedRoute>
          } />
          <Route path="/prototype/5" element={
            <ProtectedRoute>
              <Prototype5 />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </FleetProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
